import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtDate, fmtQ } from "@/merenda/common";

const LABEL = { INICIAL: "Estoque inicial", ENTRADA: "Entrada (NF)", CONSUMO: "Consumo", CORRECAO: "Correção", PERDA: "Perda", AJUSTE: "Ajuste" };

export const MovementsDialog = ({ food, ym, scopeParams, onClose }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/merenda/movements", { params: { food_id: food.food_id, ...(ym ? { ym } : {}), ...scopeParams } }).then((r) => setRows(r.data));
  }, [food, ym, scopeParams]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-2xl overflow-y-auto" data-testid="movements-dialog">
        <DialogHeader><DialogTitle>Lançamentos — {food.name} ({food.unit})</DialogTitle></DialogHeader>
        <Table>
          <TableHeader><TableRow><TableHead>Data</TableHead><TableHead>Tipo</TableHead><TableHead className="text-right">Qtd.</TableHead><TableHead>Origem / motivo</TableHead></TableRow></TableHeader>
          <TableBody>
            {(rows || []).map((m) => (
              <TableRow key={m.id}>
                <TableCell>{fmtDate(m.date)}</TableCell><TableCell>{LABEL[m.type] || m.type}</TableCell>
                <TableCell className={`text-right font-semibold ${m.delta < 0 ? "text-red-600" : "text-green-700"}`}>{m.delta > 0 ? "+" : ""}{fmtQ(m.delta)}</TableCell>
                <TableCell className="text-xs text-slate-500">{m.reason || ""} · {m.created_by_name}</TableCell>
              </TableRow>
            ))}
            {rows && !rows.length && <TableRow><TableCell colSpan={4} className="text-center text-slate-400">Nenhum lançamento</TableCell></TableRow>}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};
